import {SmartTable} from "../../../../../../components/smart-table/smart-table.model";

export class Controller {

    /** @ngInject */
    constructor($location, $state, $uibModal, Alert, HardTokenResource) {
        this.$location = $location;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.Alert = Alert;
        this.HardTokenResource = HardTokenResource;
    }

    $onInit() {
        this.st = new SmartTable();
        this.companyUser = this.resolve.companyUser;
        this.companyId = this.resolve.companyId;
        this.hardTokens = this.resolve.hardTokens.filter((token)=>token.isSecondaryDeviceOfUser===false);
    }

    assingTokenSecondary(tokenId){
        this.HardTokenResource
            .assingTokenAsSecondary(this.companyId,this.companyUser.id,tokenId)
            .then((data) => {
                this.$state.reload('company.user-directories.manage-user');
                this.Alert('success', 'company.user-directories.manage-user.device_assigned');
            })
    }
    showConformModal(token) {
        this.close();
        this.$uibModal.open({
            component: 'companyUserDirectoriesManageUserDetailsAssignHardTokenConfirmAssign',
            resolve: {
                companyUser: () => this.companyUser,
                token:()=>token,
                companyId:()=>this.companyId
            },
        })
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/assign-hard-token/assign-hard-token.controller.js